import SwitchingCategoriesIcon from "../../../assets/Switching/switchingCategoriesIcon.svg";
import type { ProductGroup } from "../../../types";

export const professionalMax: ProductGroup = {
  id: "professionalMax",
  title: "productGroup.professionalMax.title",
  icon: {
    src: SwitchingCategoriesIcon,
    width: 64,
    height: 40,
  },
};
